// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1K8-x","content":"styles_content__2WmdL"};